module.exports = __webpack_public_path__ + "static/media/ComputerTalk_Step1b_Image13.41397153.jpg";